import React, {useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';
import useFetchTheatron from "../hooks/useFetchTheatron";

const config = {
  metaDescription: 'Find out latest upcoming live theatre, musical, comedy, concert, and dance performances near you.',
  metaTags: 'theatre, play, performing arts, online, streaming',
  metaImage: 'https://www.cloudtix.co/static/images/og-image.jpg',
};

const SEOHelmet = ({
  title,
  prefixTitle = true,
  description,
  image,
  url,
  tags = [],
  type,
  children,
}) => {
  const theatron = useFetchTheatron();

  title = prefixTitle && title ? title + ' - ' + theatron.data?.name : theatron.data?.name;
  const location = useLocation();

  useEffect(() => {
    if (typeof window != 'undefined') {
      config.url = window.location.origin;
      config.currentUrl = window.location.href;
    } else if (typeof context != 'undefined') {
      config.url = context.origin;
      config.currentUrl = context.origin + context.url;
    } else {
      config.url = 'https://www.cloudtix.co';
      config.currentUrl = 'https://www.cloudtix.co';
    }
  }, [location]);

  return (
    <Helmet>
      <title>{title}</title>

      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />

      <link rel="canonical" href={url || config.currentUrl} />
      <meta property="og:url" content={url || config.currentUrl} />
      <meta name="twitter:url" content={url || config.currentUrl} />

      <meta
        name="description"
        content={description || config.metaDescription}
      />
      <meta
        property="og:description"
        content={description || config.metaDescription}
      />
      <meta
        name="twitter:description"
        content={description || config.metaDescription}
      />

      <meta
        property="og:image"
        content={image ? image : config.url + config.metaImage}
      />
      <meta
        name="twitter:image"
        content={image ? image : config.url + config.metaImage}
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta
        name="keywords"
        content={tags ? Array.isArray(tags) ? tags.join(', ') : tags : config.metaTags}
      />

      <meta property="og:type" content={type || 'website'} />

      {children}
    </Helmet>
  );
};

export default SEOHelmet;
